import { render } from "./LoadMenu.vue?vue&type=template&id=2893d606&scoped=true&ts=true"
import script from "./LoadMenu.vue?vue&type=script&lang=ts"
export * from "./LoadMenu.vue?vue&type=script&lang=ts"

import "./LoadMenu.vue?vue&type=style&index=0&id=2893d606&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2893d606"]])

export default __exports__